import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import { createPinia } from 'pinia'
import { BootstrapVue3 } from 'bootstrap-vue-3'
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap 5 CSS
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import globalMixins from './mixin/globals'
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";
import 'chartjs-adapter-date-fns';  // 날짜 어댑터 등록

import { Line, Bar } from 'vue-chartjs';
// import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js';
//
// ChartJS.register(Title, Tooltip, Legend, ArcElement, LineElement, PointElement, CategoryScale, LinearScale);
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, BarElement, LineElement, PointElement, CategoryScale, LinearScale, TimeScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, BarElement, LineElement, PointElement, CategoryScale, LinearScale, TimeScale); // 한 번만 등록

//import { Line, Bar } from 'vue-chartjs';





dayjs.extend(relativeTime);
dayjs.locale("ko", {
    relativeTime: {
        future: '%s 후',
        past: '%s 전',
        s: '몇 초',
        m: '1분',
        mm: '%d분',
        h: '1시간',
        hh: '%d시간',
        d: '1일',
        dd: '%d일',
        M: '1개월',
        MM: '%d개월',
        y: '1년',
        yy: '%d년',
    },
});

const app = createApp(App);

// Vue 3에서는 .use()로 플러그인 등록
app.use(globalMixins); // 글로벌 믹스인 등록
app.use(BootstrapVue3); // BootstrapVue3 플러그인 등록

//app.use(ChartJS); // BootstrapVue3 플러그인 등록
//app.use(Line); // BootstrapVue3 플러그인 등록
//app.use(Bar); // BootstrapVue3 플러그인 등록
app.use(router); // Vue Router 등록
app.use(createPinia()); // Pinia 상태 관리 등록

app.config.productionTip = false; // productionTip 설정

// 앱 마운트
app.mount('#app');